import { GameTypeName } from '@loyalty/shared-common/premium-games-api-client';
import { CardLayouts } from '../participant-frontend-components/components/campaign-card/layouts';
import { GenericComponent, WidgetProps } from '../participant-frontend-components';

/** How the advanced format game is shown to participants (no modal). */
export enum AdvancedFormatOpenType {
  iframe = 'iframe',
  newTab = 'new_tab',
}

export interface AdvancedFormatComponentAttributes {
  /** Uuid of the selected premium game. */
  configId?: string;
  /** @deprecated superseded by {@link AdvancedFormatComponentAttributes.configId}. */
  configUrl?: string;
  gameType?: GameTypeName;
  id?: string;
  class?: string;
  /** Defaults to iframe when omitted (existing widgets). */
  openType?: AdvancedFormatOpenType;
  template?: CardLayouts | string;
}

export interface AdvancedFormatComponentI18nAttributes {
  title?: string;
  image?: string;
  description?: string;
  ctaLabel?: string;
}

type AdvancedFormatEditorComponent = GenericComponent<
  AdvancedFormatComponentAttributes,
  AdvancedFormatComponentI18nAttributes
>;

export type AdvancedFormatBackendProps = WidgetProps<AdvancedFormatEditorComponent>;
